"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetCollectionImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing AssetCollection operations. */
var AssetCollectionImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class AssetCollection class.
   * @param client Reference to the service client
   */
  function AssetCollectionImpl(client) {
    (0, _classCallCheck2["default"])(this, AssetCollectionImpl);
    this.client = client;
  }
  /**
   * Retrieves the non-archived collections for which the current user has at least read access. (Auth:
   * Authorize)
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(AssetCollectionImpl, [{
    key: "getAssetCollectionsForCurrentUser",
    value: function getAssetCollectionsForCurrentUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionsForCurrentUserOperationSpec);
    }
    /**
     * Get the archived collections for the current. Only collections for which the user has "security"
     * privilege (is the owner) are returned. (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getArchivedAssetCollectionsForCurrentUser",
    value: function getArchivedAssetCollectionsForCurrentUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getArchivedAssetCollectionsForCurrentUserOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getAssetCollectionById",
    value: function getAssetCollectionById(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionByIdOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "copyAssetCollection",
    value: function copyAssetCollection(portalId, assetCollectionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, copyAssetCollectionOperationSpec);
    }
    /**
     * Archives (soft delete) a collection (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "archiveAssetCollection",
    value: function archiveAssetCollection(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, archiveAssetCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getUsersByCollection",
    value: function getUsersByCollection(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getUsersByCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "addMembersToCollection",
    value: function addMembersToCollection(portalId, assetCollectionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addMembersToCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param userId
     * @param options The options parameters.
     */

  }, {
    key: "removeMemberFromCollection",
    value: function removeMemberFromCollection(portalId, assetCollectionId, userId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        userId: userId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, removeMemberFromCollectionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getAssetCollectionPermissions",
    value: function getAssetCollectionPermissions(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getAssetCollectionPermissionsOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "updateAssetCollection",
    value: function updateAssetCollection(portalId, assetCollectionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, updateAssetCollectionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "addDocumentsToNewCollection",
    value: function addDocumentsToNewCollection(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addDocumentsToNewCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param body Array of AssetCollectionDocumentAdditionModel
     * @param options The options parameters.
     */

  }, {
    key: "addDocumentsToExistingCollection",
    value: function addDocumentsToExistingCollection(portalId, assetCollectionId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, addDocumentsToExistingCollectionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param documentId
     * @param documentRevisionId
     * @param options The options parameters.
     */

  }, {
    key: "postDocumentToNewCollection",
    value: function postDocumentToNewCollection(portalId, documentId, documentRevisionId, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        documentRevisionId: documentRevisionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postDocumentToNewCollectionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param documentId
     * @param documentRevision
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postQuoteAssetToNewCollection",
    value: function postQuoteAssetToNewCollection(portalId, documentId, documentRevision, body, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        documentRevision: documentRevision,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postQuoteAssetToNewCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param documentId
     * @param documentRevisionNumber
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postQuoteAssetToExistingCollection",
    value: function postQuoteAssetToExistingCollection(portalId, assetCollectionId, documentId, documentRevisionNumber, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        documentId: documentId,
        documentRevisionNumber: documentRevisionNumber,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postQuoteAssetToExistingCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param documentId
     * @param documentRevisionNumber
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postPdfQuoteAssetToExistingCollection",
    value: function postPdfQuoteAssetToExistingCollection(portalId, assetCollectionId, documentId, documentRevisionNumber, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        documentId: documentId,
        documentRevisionNumber: documentRevisionNumber,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postPdfQuoteAssetToExistingCollectionOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param documentId
     * @param documentRevisionNumber
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "postPdfQuoteAssetToNewCollection",
    value: function postPdfQuoteAssetToNewCollection(portalId, documentId, documentRevisionNumber, body, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        documentRevisionNumber: documentRevisionNumber,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postPdfQuoteAssetToNewCollectionOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "postFile",
    value: function postFile(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, postFileOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param assetItemId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "moveItemToLocation",
    value: function moveItemToLocation(portalId, assetCollectionId, assetItemId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        assetItemId: assetItemId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, moveItemToLocationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param sourceFolderId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "moveAllChildrenToLocation",
    value: function moveAllChildrenToLocation(portalId, assetCollectionId, sourceFolderId, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        sourceFolderId: sourceFolderId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, moveAllChildrenToLocationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param sourceFolderId
     * @param index
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "moveChildrenBeforeIndexToLocation",
    value: function moveChildrenBeforeIndexToLocation(portalId, assetCollectionId, sourceFolderId, index, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        sourceFolderId: sourceFolderId,
        index: index,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, moveChildrenBeforeIndexToLocationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param sourceFolderId
     * @param index
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "moveChildrenOnOrAfterIndexToLocation",
    value: function moveChildrenOnOrAfterIndexToLocation(portalId, assetCollectionId, sourceFolderId, index, body, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        sourceFolderId: sourceFolderId,
        index: index,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, moveChildrenOnOrAfterIndexToLocationOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param assetItemId
     * @param options The options parameters.
     */

  }, {
    key: "downloadBlob",
    value: function downloadBlob(portalId, assetCollectionId, assetItemId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        assetItemId: assetItemId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, downloadBlobOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[portalId, assetCollectionId])
     * @param portalId (Access Controlled)
     * @param assetCollectionId (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "createAssetCollectionTemplate",
    value: function createAssetCollectionTemplate(portalId, assetCollectionId, options) {
      var operationArguments = {
        portalId: portalId,
        assetCollectionId: assetCollectionId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, createAssetCollectionTemplateOperationSpec);
    }
  }]);
  return AssetCollectionImpl;
}(); // Operation Specifications


exports.AssetCollectionImpl = AssetCollectionImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getAssetCollectionsForCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections/My",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.count, Parameters.permission],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getArchivedAssetCollectionsForCurrentUserOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections/My/Archived",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  queryParameters: [Parameters.count],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getAssetCollectionByIdOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Single",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionViewModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var copyAssetCollectionOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Copy",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body5,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var archiveAssetCollectionOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  serializer: serializer
};
var getUsersByCollectionOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/users",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "AssetCollectionMemberViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var addMembersToCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets({assetCollectionId})/users",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body6,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var removeMemberFromCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets({assetCollectionId})/users/{userId}/remove",
  httpMethod: "DELETE",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.userId],
  serializer: serializer
};
var getAssetCollectionPermissionsOperationSpec = {
  path: "/api/Portals({portalId})/Assets/permissions",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "PermissionViewModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId1],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var updateAssetCollectionOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Update",
  httpMethod: "PUT",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body5,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var addDocumentsToNewCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body7,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var addDocumentsToExistingCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets/{assetCollectionId}",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body8,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var postDocumentToNewCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets/{documentId}/{documentRevisionId}",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId, Parameters.documentRevisionId],
  serializer: serializer
};
var postQuoteAssetToNewCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets/Annotation/{documentId}/{documentRevision}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body9,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId, Parameters.documentRevision],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var postQuoteAssetToExistingCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets({assetCollectionId})/Annotation/{documentId}/{documentRevisionNumber}",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body10,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.documentId, Parameters.documentRevisionNumber],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var postPdfQuoteAssetToExistingCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets({assetCollectionId})/PdfQuote/{documentId}/{documentRevisionNumber}",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body11,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.documentId, Parameters.documentRevisionNumber],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var postPdfQuoteAssetToNewCollectionOperationSpec = {
  path: "/api/Portals({portalId})/Assets/PdfQuote/{documentId}/{documentRevisionNumber}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionViewModel
    },
    401: {},
    403: {}
  },
  requestBody: Parameters.body12,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId, Parameters.documentRevisionNumber],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var postFileOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/File",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "NodeInfo"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  formDataParameters: [Parameters.file],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.contentType1, Parameters.accept2],
  serializer: serializer
};
var moveItemToLocationOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Item({assetItemId})/Moves",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body13,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetItemId, Parameters.assetCollectionId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var moveAllChildrenToLocationOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Folders({sourceFolderId})/Children/Moves",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body13,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.sourceFolderId],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var moveChildrenBeforeIndexToLocationOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Folders({sourceFolderId})/ChildrenBefore({index})/Moves",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body13,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.sourceFolderId, Parameters.index],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var moveChildrenOnOrAfterIndexToLocationOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Folders({sourceFolderId})/ChildrenOnOrAfter({index})/Moves",
  httpMethod: "POST",
  responses: {
    200: {},
    401: {},
    403: {}
  },
  requestBody: Parameters.body13,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId, Parameters.sourceFolderId, Parameters.index],
  headerParameters: [Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var downloadBlobOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Node({assetItemId})/Content",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetItemId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept3],
  serializer: serializer
};
var createAssetCollectionTemplateOperationSpec = {
  path: "/api/Portals({portalId})/AssetCollections({assetCollectionId})/Template",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.AssetCollectionTemplateViewModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.assetCollectionId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};